export default {
  viewBox: "0 0 24 24",
  html: "<path fill-rule=\"evenodd\" d=\"M16.5 13v2.82l2.44 1.41-.75 1.3L15 16.69V13zM5 8v11h4.67c-.43-.91-.67-1.93-.67-3a7 7 0 0 1 7-7c1.07 0 2.09.24 3 .67V8zM3 19V5c0-1.11.89-2 2-2h1V1h2v2h8V1h2v2h1a2 2 0 0 1 2 2v6.1c1.24 1.26 2 2.99 2 4.9a7 7 0 0 1-7 7c-1.91 0-3.64-.76-4.9-2H5a2 2 0 0 1-2-2m13-7.85a4.85 4.85 0 1 0 0 9.7 4.85 4.85 0 0 0 0-9.7\"/>"
};